import styles from './SavedJobsDashboard.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { StarIcon, ChevronIcon } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';
import DashboardItem from 'DashboardItem/DashboardItem';
import DashboardHeading from 'DashboardHeading/DashboardHeading';
import { ScreenReaderOnly } from 'seek-style-guide/react';

@connect(({ dashboard }) => ({
  savedJobs: dashboard.savedJobs.data,
  totalCount: dashboard.savedJobs.totalCount,
  displayTotalCount: dashboard.savedJobs.displayTotalCount
}))
export default class SavedJobsDashboard extends Component {

  static propTypes = {
    savedJobs: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        advertiser: PropTypes.string.isRequired,
        daysAgo: PropTypes.string.isRequired,
        jobStatus: PropTypes.string.isRequired
      })
    ),
    totalCount: PropTypes.number,
    displayTotalCount: PropTypes.string
  };

  static defaultProps = {
    savedJobs: [],
    totalCount: 0,
    displayTotalCount: '0'
  };

  renderJobItem(savedJob) {
    const {
      id,
      title,
      advertiser,
      jobStatus
    } = savedJob;
    const isExpired = jobStatus === 'expired';

    /* eslint-disable react/jsx-no-bind */
    return (
      <DashboardItem
        key={id}
        heading={() => (
          <span>
            {
              isExpired &&
                <span data-automation="savedJobExpired">
                  Expired<ScreenReaderOnly>job</ScreenReaderOnly>
                  <span>{' — '}</span>
                </span>
            }
            <ExternalLink
              className={styles.headingLink}
              analytics="dashboard-save-job-click"
              data-automation="savedJobHeadingLink"
              href={`/${isExpired ? 'expiredjob' : 'job'}/${id}?ref=beta`}>
              {title}
              <ScreenReaderOnly>. At {advertiser}</ScreenReaderOnly>
            </ExternalLink>
          </span>
        )}
        subheading={() => (
          <span aria-hidden="true" data-automation="savedJobAdvertiser">
            {advertiser}
          </span>
        )}
      />
    );
    /* eslint-enable react/jsx-no-bind */
  }

  render() {
    const { savedJobs, totalCount, displayTotalCount } = this.props;
    const label = `Saved ${totalCount === 1 ? 'job' : 'jobs'}`;

    return (
      <nav role="navigation" data-automation="savedJobsDashboard">
        <DashboardHeading
          label={label}
          count={displayTotalCount}
          Icon={StarIcon}
          iconClass={styles.icon}
          className={styles.heading}
          href="/my-activity/saved-jobs"
          analytics="dashboard-heading-saved-jobs-click"
        />
        {
          savedJobs.length > 0 &&
            <div className={styles.items}>
              { savedJobs.map(this.renderJobItem) }
            </div>
        }
        {
          savedJobs.length > 0 &&
            <ExternalLink
              className={styles.viewAll}
              data-automation="savedJobViewSavedJobs"
              analytics="dashboard-all-saved-jobs-click"
              href="/my-activity/saved-jobs">
              View all<ScreenReaderOnly>your saved jobs</ScreenReaderOnly>
              <ChevronIcon
                className={styles.chevron}
                direction="right"
                svgClassName={styles.chevronSvg}
              />
            </ExternalLink>
        }
        {
          savedJobs.length === 0 &&
            <p className={styles.noItems}>
              {'Use the '}
              <span className={styles.noItems_highlight}>
                <StarIcon svgClassName={styles.iconSvg} />
                {' Save '}
              </span>
              button on each job listing to save it for later. You can then access
              them on all your devices.
            </p>
        }
      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/SavedJobsDashboard/SavedJobsDashboard.js
 **/